
import "../Text/Text.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/typography.st.css.js";
import "../Tooltip/Tooltip.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_SidebarItemNext";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_SidebarItemNext__root","text-small-normal":"wds_1_209_0_StylableTypography__text-small-normal","text":"wds_1_209_0_SidebarItemNext__text","prefix":"wds_1_209_0_SidebarItemNext__prefix","divider":"wds_1_209_0_SidebarItemNext__divider","suffix":"wds_1_209_0_SidebarItemNext__suffix","listItem":"wds_1_209_0_SidebarItemNext__listItem","textWrapper":"wds_1_209_0_SidebarItemNext__textWrapper","suffixContainer":"wds_1_209_0_SidebarItemNext__suffixContainer","tooltipWrapper":"wds_1_209_0_SidebarItemNext__tooltipWrapper","tooltip":"wds_1_209_0_SidebarItemNext__tooltip"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




